import { prettyPrintLabel } from '../utils';
export function generateVariable(variable) {
  return {
    inline: true,
    group: 'inline',
    draggable: true,
    atom: true,
    selectable: true,
    attrs: {
      type: {
        default: variable
      },
      isVariable: {
        default: true
      }
    },
    toDOM(node) {
      const isInvalid = variable === 'invalid';
      return ['span', {
        'var-type': node.attrs.type,
        class: `ProseMirror__pillbox ${node.attrs.type}${isInvalid ? ' ProseMirror__pillbox--invalid' : ''}`
      }, prettyPrintLabel(variable)];
    },
    parseDOM: [{
      tag: 'span[var-type]',
      getAttrs: dom => {
        const type = dom.getAttribute('var-type');
        return type === variable ? {
          type
        } : false;
      }
    }]
  };
}